<template>
  <v-container fill-height fluid class="pa-0 login-container">
    <v-row no-gutters class="fill-height login-row">
      <v-col class="pa-0 image-column">
        <v-img 
          :src="loginImgSrc" 
          class="fill-height"
          position="left center"
          cover
          style="max-width: 1600px; max-height: 1300px;"
          eager
          @error="handleImageError"
          @load="handleImageLoad"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-col>
      
      <v-col 
        class="pa-0 d-flex align-center justify-center white form-column"
      >
        <div class="login-form-wrapper px-6 py-4">

          <div class="logo-container">
            <app-headerlogo />
          </div>

          <v-card flat color="transparent">
            <v-card-text class="pa-0">
              <v-form id="login-form" v-on:submit.prevent="login">
                <h3 class="mb-1">{{ $t('login.username') }}</h3>
                <v-text-field
                  id="username"
                  v-model="username"
                  dense
                  outlined
                  rounded
                  hide-details="auto"
                  class="mb-6"
                />
                <h3 class="mb-1">{{ $t('login.password') }}</h3>
                <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  id="password"
                  v-model="password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  dense
                  outlined
                  rounded
                  hide-details="auto"
                  class="mb-4"
                />
              </v-form>
            </v-card-text>
            
            <div v-if="errorMsg" class="error-message red--text text-caption mb-3">
              {{ errorMsg }}
            </div>
            
            <v-card-actions class="pa-0 flex-column">
              <v-btn 
                color="blue-grey" 
                dark
                type="submit" 
                form="login-form" 
                block
                rounded
                elevation="2"
                class="mb-3"
              >
                {{ $t("login.signin") }}
              </v-btn>
              
              <v-btn 
                v-on:click="forgotbtn()" 
                color="success" 
                block
                outlined
                rounded
                class="mb-3"
              >
                {{ $t("login.forgot_password") }}
              </v-btn>
              
              <app-lang-switch />
            </v-card-actions>
          </v-card>
        </div>
        <app-footer />
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}
.logo-container {
  max-width: 350px;
  width: 100%;
  margin: 0 auto 40px;
  display: flex;
  justify-content: center;
}

#app-headerlogo .v-img {
  width: 100%; 
  height: auto;
  object-fit: contain;
}

.error-message {
  text-align: center;
  font-size: 0.875rem;
}

.login-container {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
}

.login-row {
  flex-wrap: nowrap !important;
  height: 100%;
  width: 100%;
  display: flex !important;
  position: relative;
}

.image-column {
  position: absolute !important;
  top: 0;
  left: 0;
  width: calc(100% - 400px) !important;
  height: 100vh;
  z-index: 1;
}

.image-column .v-image {
  width: 100%;
  height: 100%;
  min-height: 100vh;
}

.image-column .v-image >>> .v-image__image,
.image-column .v-image::v-deep .v-image__image {
  background-size: cover !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
}

.form-column {
  height: 100vh;
  width: 400px !important;
  min-width: 400px !important;
  max-width: 400px !important;
  flex: 0 0 400px !important;
  min-height: 100vh;
  position: relative;
  z-index: 100;
  background-color: white !important;
  margin-left: auto;
}

@media (max-width: 500px) {
  .image-column {
    display: none;
  }
  
  .form-column {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    flex: 1 1 auto !important;
    margin-left: 0;
  }
}

.login-form-wrapper {
  width: 100%;
  max-width: 350px;
  position: relative;
  z-index: 100;
  transition: all 0.3s ease-in;
  padding-top: 1rem !important;
}
</style>

<script>
//import i18n from '../../i18n';
import LangSwitch from "../common/LangSwitch";
import axios from "axios";
import crypto from "crypto-js";
import HeaderLogo from '../common/HeaderLogo.vue';
import Footer from "../common/Footer.vue";

export default {
  components: {
    "app-lang-switch": LangSwitch,
    "app-headerlogo": HeaderLogo,
    "app-footer": Footer,
  },

  data() {
    return {
      showPassword: false,
      username: null,
      password: null,
      errorMsg: null,
      ip: "",
      loginImgSrc: null,
      db: this.$route.params.db,
      apiReady: false,
    };
  },

  methods: {
    forgotbtn() {
      this.$router.push({ name: "forgotpassword", params: {db: this.$route.params.db} });
    },
    login() {
      const vm = this;
      vm.errorMsg = null;
      this.$store
        .dispatch("retrvAccessToken", {
          username: vm.username,
          password: String(crypto.AES.encrypt(vm.password, 'secret_t2hr')),
          ip: vm.ip,
          origin: 'browser',
          db: this.$route.params.db
        })
        .then((res) => {
          if (res.data.status == 400 && res.data.errornum == 1) { // First Time Login
            this.$router.push({
              name: "firsttimelogin",
              params: { id: res.data.userid, db: this.$route.params.db },
            });
          } else if (
            res.data.status == 400 &&
            res.data.errornum == 2 // Reset password
          ) {
            this.$router.push({
              name: "firsttimelogin",
              params: { id: res.data.userid, db: this.$route.params.db },
            });
          } else if (res.data.status == 201) {
            // this.$router.push({ name: "dashboard" });
            if(res.data.funcaccess.length > 0) { // Checking if admin or not. If admin go to dashboard page
              this.$router.push({ name: "dashboard" });
            } else {
              this.$router.push({ name: "selfservicehome" });
            }            
          } else {
            vm.errorMsg = res.data.error;
          }

          if(this.username == null || this.password == null || 
             this.username == '' || this.password == '' || 
             this.username == null && this.password == null
             || this.username == '' && this.password == ''){
             this.$dialog.alert(this.$t('userandpassrequired')).then((dialog) => {
                console.log('dailog', dialog);
             });
          }

        })
        .catch((error) => {
          vm.errorMsg = error;
        });
    },

    async loadLoginImg() {
      const vm = this;

      if (!this.apiReady) {
        console.log("API not ready yet, skipping image load");
        return;
      }

      try {
        const res = await this.$store.dispatch('get', {url: "/loginimg/all/" + this.db});

        // console.log("Response received:", res.data);

        if (res.data.rec.length > 0 && res.data.rec[0].loginImg) {
          const imgData = res.data.rec[0].loginImg;
          console.log("Image data length:", imgData.length);
          // console.log("Image data starts with:", imgData.substring(0, 50));

          vm.loginImgSrc = imgData;
          return;
        } else {
          console.log("No image found in response");
        }
      } catch(err) {
        console.error("Error loading table img:", err);
      }
    },

    handleImageError(error) {
      console.log("Image failed to load:", error);
    },

    handleImageLoad() {
      console.log("Image loaded successfully");
    }
  },

  async mounted() {
    this.$root.$on('api-ready', async() => {
      // console.log("API is ready, loading images...");
      this.apiReady = true;

      if (this.db && this.db !== 'null') {
        await this.loadLoginImg();
      }
    });

    if (this.$store.getters.apiUrl) {
      // console.log("API already configured, loading images...");
      this.apiReady = true;

      if (this.db && this.db !== 'null') {
        await this.loadLoginImg();
      }
    }

    axios
      .get("https://api.ipify.org?format=json", {})
      .then((res) => {
        console.log(res);
        this.ip = res.data.ip;
      })
      .catch((error) => {
        console.log(error);
      });
  },

  beforeDestroy() {
    // Clean up event listener
    this.$root.$off('api-ready');
  }
};
</script>